<template>
  <v-card>
    <v-card-title class="headline pb-0">
      Карточка компании
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-container fluid grid-list-lg class="pa-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-tabs v-model="activeTab" dark color="cyan" show-arrows slider-color="blue">
              <v-tab href="#main">Основное</v-tab>
              <v-tab href="#structure">Структура</v-tab>
              <v-tab href="#edit-element" v-show="editElement">Редактировать элемент</v-tab>
              <v-tabs-items>
                <v-tab-item value="main">
                  <v-card flat>
                    <v-flex xs12>
                      <v-text-field label="Название компании" v-model="company.name" :readonly="!editname" @keyup.enter="saveField('name')" @keyup.esc="editField('name', false)">
                        <template slot="append-outer" v-if="editname">
                          <v-icon color="blue" class="pointer mr-2" @click="saveField('name')">save</v-icon>
                          <v-icon class="pointer" @click="editField('name', false)">close</v-icon>
                        </template>
                        <v-icon v-else slot="append-outer" color="green" class="pointer" @click="editField('name', true)">edit</v-icon>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 class="pa-0">
                      <v-btn small color="success ml-0" @click="restoreElement('company')">Активировать</v-btn>
                      <v-btn small color="amber ml-0" @click="deleteElement('company',false)">Деактивировать</v-btn>
                      <v-btn small color="error" @click="deleteElement('company',true)"><v-icon left dark>mdi-alert</v-icon>Удалить безвозвратно</v-btn>
                    </v-flex>
                  </v-card>
                </v-tab-item>
                
                <v-tab-item value="structure">
                  <v-card flat class="my-2">
                    <v-treeview v-model="tree" :items="tree_items" activatable>
                      <v-icon slot="prepend" slot-scope="{ item, open, leaf }" :color="item.iconcolor"> {{ item.icon }}</v-icon>
                      <label slot="label" slot-scope="{ item, active, leaf }" :class="{inactive:!item.status}" @click="editElement=false">{{item.name}}</label>
                      <v-btn slot="append" slot-scope="{ item, active, leaf }" small icon v-if="active" @click.stop="updateElement(item)" class="mx-1"><v-icon color="green">mdi-pencil</v-icon></v-btn>
                    </v-treeview>
                  </v-card>
                </v-tab-item>
                
                <v-tab-item value="edit-element" v-if="editElement">
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <v-chip :color="element.status?'success':''">{{element.status?'Активный':'Удален'}}</v-chip>
                        <p>Создан: {{element.created}}</p>
                        <p v-if="element.deleted">Удален: {{element.deleted}}</p>
                      </v-flex>
                      <v-flex xs12 sm6 class="px-0">
                        <v-btn small color="success ml-0" @click="restoreElement(element.element_type)">Активировать</v-btn><br>
                        <v-btn small color="amber ml-0" @click="deleteElement(element.element_type, false)">Деактивировать</v-btn><br>
                        <v-btn small color="error ml-0" @click="deleteElement(element.element_type, true)"><v-icon left dark>mdi-alert</v-icon>Удалить безвозвратно</v-btn>
                      </v-flex>
                    </v-layout>
                    <hr>
                    <v-flex xs12>
                      <v-text-field label="Название" v-model="element.name"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <p class="grey--text mb-0 subheading text--darken-1">Описание</p>
                      <dantser-editor v-model="element.description" :init="config" :api-key="apiKey"></dantser-editor>
                    </v-flex>
                    <v-flex xs12 style="max-height: 300px">
                      <template v-if="showParentTree">
                        <p class="grey--text mb-0 subheading text--darken-1">Подразделение, которому подчиняется</p>
                        <v-treeview :items="containers_tree" activatable :active="[element.parent_id]" open-all>
                          <v-icon slot="prepend" slot-scope="{item}" :color="item.iconcolor">{{item.icon}}</v-icon>
                          <label slot="label" slot-scope="{item}" class="pointer" @dblclick.stop="selectParent(item)">{{item.name}}</label>
                        </v-treeview>
                      </template>
                      <v-text-field label="Подразделение, которому подчиняется" :value="parentName" readonly v-else>
                        <v-icon v-if="containers_tree.length>0" slot="append-outer" class="pointer" @click="showParentTree=true">mdi-sitemap</v-icon>
                      </v-text-field>
                      <v-btn color="primary" class="mx-0" @click="saveElement">Сохранить</v-btn>
                    </v-flex>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  import apiOrgstructure from '@/api/orgstructure'
  import treemixin from '@/mixins/treeMixin'
  import {mapState} from 'vuex'
  
  export default {
    name : "CompanyForm",
    
    props: {
      data: {
        type: Object,
        required: true,
      }
    },
  
    mixins: [treemixin],
  
    data: () => ({
      activeTab: null,
      company: {},
      editname: false,
      tempname: '',
      tree: [],
      tree_items: [],
      editElement: false,
      element: {},
      containers_tree: [],
      parentName: '',
      showParentTree: false
    }),
  
    computed:{
      ...mapState('app', {
        editorConfig: state => state.editorBaseConfig,
        apiKey: state => state.editorApiKey,
      }),
      config(){
        let conf = {...this.editorConfig}
        conf.toolbar = 'bold italic strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify  | numlist bullist | removeformat'
        return conf
      }
    },
  
    created(){
      this.company = JSON.parse(JSON.stringify(this.data))
  
      apiOrgstructure.companyTree(this.company.id).then( response => {
        this.tree_items = response
      })
    },
    
    methods:{
      editField(field, status){
        switch(field){
          case 'name':
            this.editname = status
            if(status){
              this.tempname = this.company.name
            } else {
              this.company.name = this.tempname
            }
            break
        }
      },
  
      saveField(field){
        switch(field){
          case 'name':
            this.editname = false
            break
        }
        let data = {}
        data.id = this.company.id
        data[field] = this.company[field]
        apiOrgstructure.updateCompany(data).then( response => {
          this.$dmsSuccessNoty('Компания успешно обновлена')
          this.$emit('save', {type: 'updateCompany', data: this.company, dialog: true})
        }).catch( error => {
          this.$dmsErrorNoty('Возникла ошибка в процессе выполения действия')
        })
      },
  
      deleteElement(type, hard=false){
        let message = ''
        let nowdate = new Date();
        let date = nowdate.getFullYear() + "-" + ('0' + (nowdate.getMonth() + 1)).slice(-2) + "-" + nowdate.getDate()
        
        switch(type){
          case 'company':
            message = 'Вы уверены, что хотите удалить компанию?'
            if(hard) message = 'Вы точно хотите полностью безвозвратно бескомпромиссно бесповоротно необратимо удалить компанию? Подумайте 2 раза'
            this.$dmsAgree(message).then( _ => {
              let deletePromise = null;
              if(hard) {
                deletePromise = apiOrgstructure.companyHardDelete( this.company.id )
              } else {
                deletePromise = apiOrgstructure.deleteCompany( this.company.id )
              }
              deletePromise.then( response => {
                this.$dmsSuccessNoty('Компания успешно удалена')
                this.$emit('save', {type: 'deleteCompany', data: {id: this.company.id, hard }, dialog: !hard })
              }).catch( error => {
                this.$dmsErrorNoty('Возникла ошибка в процессе выполения действия')
              })
            })
            break
          case 'post':
            message = 'Вы уверены, что хотите удалить пост?'
            if(hard) message = 'Пост и все его данные будут удалены без возможности восстановления. Вы уверены, что хотите удалить пост?'
            this.$dmsAgree(message).then( _ => {
              let deletePromise = null;
              if(hard) {
                deletePromise = apiOrgstructure.postHardDelete( this.element.id )
              } else {
                deletePromise = apiOrgstructure.deletePost( this.element.id )
              }
              deletePromise.then( response => {
                this.$dmsSuccessNoty('Пост успешно удален.')
                if(hard) {
                  this.deleteNodeById(this.element.id, this.tree_items)
                  this.clearEdit()
                } else {
                  this.element.status = false
                  this.element.deleted = date
                }
              }).catch( error => {
                this.$dmsErrorNoty('Возникла ошибка в процессе выполения действия')
              })
            })
            break
          case 'container':
            message = 'Вы уверены, что хотите удалить подразделение?'
            if(hard) message = 'Подразделение и все его данные будут удалены без возможности восстановления. Вы уверены, что хотите удалить подразделение?'
            this.$dmsAgree(message).then( _ => {
              let deletePromise = null;
              if(hard) {
                deletePromise = apiOrgstructure.containerHardDelete( this.element.id )
              } else {
                deletePromise = apiOrgstructure.deleteContainer( this.element.id )
              }
              deletePromise.then( response => {
                this.$dmsSuccessNoty('Подразделение успешно удалено.')
                if(hard) {
                  this.deleteNodeById(this.element.id, this.tree_items)
                  this.clearEdit()
                } else {
                  this.element.status = false
                  this.element.deleted = date
                }
              }).catch( error => {
                this.$dmsErrorNoty('Возникла ошибка в процессе выполения действия')
              })
            })
            break
        }
      },
      
      clearEdit(){
        this.editElement = false
        this.activeTab = 'structure'
        this.element = {}
      },
  
      restoreElement(type){
        switch(type){
          case 'company':
            apiOrgstructure.restoreCompany(this.company.id).then( response => {
              this.$dmsSuccessNoty('Компания успешно восстановлена.')
              this.$emit('save', {type: 'restoreCompany', data: {id: this.company.id}, dialog: true })
            }).catch( error => {
              this.$dmsErrorNoty('Возникла ошибка в процессе выполения действия')
            })
            break
          case 'post':
            apiOrgstructure.restorePost(this.element.id).then( response => {
              this.$dmsSuccessNoty('Пост успешно восстановлен.')
              this.element.status = true
              this.element.deleted = null
            }).catch( error => {
              this.$dmsErrorNoty('Возникла ошибка в процессе выполения действия')
            })
            break
          case 'container':
            apiOrgstructure.restoreContainer(this.element.id).then( response => {
              this.$dmsSuccessNoty('Подразделение успешно восстановлено.')
              this.element.status = true
              this.element.deleted = null
            }).catch( error => {
              this.$dmsErrorNoty('Возникла ошибка в процессе выполения действия')
            })
            break
        }
      },
      
      selectParent(item){
        this.showParentTree = false
        this.element.parent_id = item.id
        this.parentName = item.name
      },
  
      updateElement(data){
        this.editElement = true
        this.element = data
        this.activeTab = 'edit-element'
  
        let id = (data.element_type==='post') ? data.parent_id : data.id
        let type = (data.element_type==='post') ? 'for_post' : 'without_current'
  
        apiOrgstructure.containersTree(id, type).then( response => {
          this.containers_tree = response
        })
        
        let node = this.getNodeByProp('id', data.parent_id, this.tree_items)
        this.parentName = (node!=null) ? node.name : 'Не указано'
        this.showParentTree = false
      },
  
      saveElement(){
        let data = {
          id: this.element.id,
          name: this.element.name,
          parent_id: this.element.parent_id,
          description: this.element.description,
        }
        if(this.element.element_type==='post'){
          apiOrgstructure.updatePost(data).then(response=>{
            this.$dmsSuccessNoty('Пост успешно обновлен.')
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка в процессе выполения действия')
          })
        } else if(this.element.element_type==='container'){
          apiOrgstructure.updateContainer(data).then(response=>{
            this.$dmsSuccessNoty('Подразделение успешно обновлено.')
          }).catch( error => {
            this.$dmsErrorNoty('Возникла ошибка в процессе выполения действия')
          })
        }
      }
    }
  }
</script>

<style scoped>
  label.inactive{
    text-decoration: line-through;
    opacity: 0.5;
  }
</style>


// WEBPACK FOOTER //
// src/apps/orgstructure/components/Forms/CompanyForm.vue